import { getAspectRatioRate } from '@zappyrent/hundop';
import { cover, rem } from 'polished';
import styled from 'styled-components';

export const StyledCtaButtonWrapper = styled.div`
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: ${rem('240px')};
  }
`;

export const StyledGridWrapper = styled.div`
  position: relative;
  width: 200%;
`;

export const StyledHeadingWrapper = styled.div`
  margin-bottom: ${rem('-24px')};
`;

export const StyledImage = styled.img`
  ${cover()}
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: ${rem('32px')};
  padding-top: ${getAspectRatioRate(16, 10)};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: 0;
    padding-top: 0;
    height: 100%;
  }
`;

export const StyledImageOuterWrapper = styled.div`
  flex: 0 0 50%;
`;

export const StyledTextInnerWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    width: 50%;
    padding: ${rem('72px')} ${rem('40px')} ${rem('72px')} 0;
  }
`;

export const StyledTextMiddleWrapper = styled.div`
  flex: 0 0 50%;
`;

export const StyledTextOuterWrapper = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    display: flex;
    flex-direction: row;
    align-items: stretch;
  }
`;

export const StyledWrapper = styled.section`
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    margin: ${rem('16px')} 0 ${rem('32px')} 0;
  }
`;

export const StyledNote = styled.small`
  display: flex;
  margin: ${rem('16px')} 0 ${rem('32px')} 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('14px')};
  line-height: 140%;
`;

export const StyledParagraph = styled.p`
  margin: 0 0 ${rem('12px')} 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('16px')};
  line-height: 140%;
`;
